import isEqual from 'lodash/isEqual';
import { useField } from 'react-final-form';
import { PolicyCardForm } from './_components/PolicyCardForm';

import {
  RffCheckbox,
  RffChipInput,
  useControlsGroupState,
  useRffFormState,
} from '@cast/shared-rff-ui';

import { Typography, Stack } from '@cast/design-system';

const initialContainerValue: string[] = [];

export const ContainerExclusionField = () => {
  const { name: enabledFieldName = '' } = useControlsGroupState({
    name: 'enabled',
  });

  const field = useField(enabledFieldName);
  const isEnabled = !!field.input.value;
  const { mode } = useRffFormState();

  return (
    <Stack gap={16} data-testid="container-exclusion-field">
      <PolicyCardForm
        label="Selectively exclude containers"
        control={
          <RffCheckbox
            name="enabled"
            size="small"
            testId="exclude-containers-enabled"
          />
        }
      />
      <RffChipInput
        testId="excluded-containers"
        name="containers"
        placeholder="e.g., sidecar"
        label={<Typography variant="P10M">Container names</Typography>}
        fieldProps={{
          isEqual: (
            previous: string[] | undefined,
            current: string[] | undefined
          ) => {
            if (
              previous === undefined &&
              isEqual(current, initialContainerValue)
            ) {
              return true;
            }
            return isEqual(previous, current);
          },
        }}
        hint={mode !== 'view' ? 'Enter comma-separated values' : undefined}
        separators={['Enter', ',', ' ']}
        showClearButton={false}
        success={false}
        disabled={!isEnabled}
      />
    </Stack>
  );
};
